import React from 'react';
import { useCustomTheme } from '../../hooks/useCustomTheme';

/**
 * Custom Toggle component that applies the primary color of the custom theme to the checked state.
 * @component
 * @param {React.LabelHTMLAttributes} rest - Additional props to pass to the Toggle component.
 * @returns {JSX.Element} CustomLabel component.
 */

export function Label({ children, style, ...rest }) {
  const { theme } = useCustomTheme();
  return (
    <label
      {...rest}
      style={{ color: theme.colors.textSecondary, ...style }}
    >
      {children}
    </label>
  );
}
